import React from 'react'
import { ClipspecContextShape } from '../clipspec-integration/ClipspecContext'
import { InflatedListItemProduct } from './ListTypes'
import Button from '../components/Button'
import { Icon } from '../components/Icon'
import { IconPlusWhite } from '../components/icons'
import './ClipspecListWorkflow.scss'
import { ClipspecWorkflow } from '../clipspec-integration/clipspec-api/ClipspecIntegrationAPI'

function getCtaText(workflow: ClipspecWorkflow): string {
  switch (workflow) {
    case ClipspecWorkflow.Consultation: return 'Add to Plan'
    case ClipspecWorkflow.Product: return 'Add to Product Set'
  }
}

export const ClipspecListWorkflow: React.FC<{
  clipspecContext: ClipspecContextShape
  configuredProducts: readonly InflatedListItemProduct[]
}> = ({
  clipspecContext,
  configuredProducts,
}) => {

  return (
    <div
      className="ClipspecListWorkflow"
    >
      <Button
        buttonStyle="green"
        disabled={configuredProducts.length === 0}
        onClick={() => {
          clipspecContext.onHandoffList(configuredProducts)
        }}
      >
        <span style={{ width: '20px' }} />
        <Icon source={IconPlusWhite} color="#fff" size={24} />
        <span style={{ padding: '0 20px 0 4px' }}>
          {getCtaText(clipspecContext.workflow)}
        </span>
      </Button>
    </div>
  )
}